import { useEffect } from 'react';
import {
    useDispatch, useSelector
} from 'react-redux';

import { AppState } from '../../../app';
import {
    fetchGetUserProfilesRequest, useSelectorUserProfiles
} from '../../../user-profiles';

export const useLoadUserProfiles = () => {
    const dispatch = useDispatch();
    const {
        isLoading,
        isError,
        data: userProfilesData
    } = useSelectorUserProfiles();
    const isInitialized = useSelector<AppState>(
        state => state.app.isInitialized
    );

    useEffect(() => {
        if (!userProfilesData && !isLoading && !isError && isInitialized) {
            dispatch(fetchGetUserProfilesRequest());
        }
    }, [userProfilesData, isLoading, isError, isInitialized, dispatch]);
};
